import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
export const PAYU_REDIRECT = new InjectionToken<string>('PAYU_REDIRECT');
